import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import { brandTitleByKey } from '@prismamedia/one-brandkey';
import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetBrandKeys } from '../../apollo/queries/getBrandKeys.newsletter.graphql';
import { LinkOnlyIcon } from './LinkOnlyIcon';
import { useStyles } from './styles';

interface SpeedDialBrandsProps {
  brand: string | null;
  basePath: string;
}

export const SpeedDialBrands: FC<SpeedDialBrandsProps> = ({
  brand,
  basePath,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [isOpen, setOpen] = useState<boolean>(false);
  const { data, loading } = useGetBrandKeys();

  if (brand) {
    return <LinkOnlyIcon path={`${basePath}${brand}`} />;
  }

  if (loading || !data) {
    return null;
  }

  return (
    <SpeedDial
      ariaLabel="SpeedDial brands"
      className={classes.speedDial}
      icon={<SpeedDialIcon />}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={isOpen}
      direction="up"
      classes={{
        actions: classes.actions,
        fab: classes.fab,
      }}
    >
      {data.getBrandKeys.map((brandKey) => (
        <SpeedDialAction
          key={brandKey}
          icon={brandKey}
          tooltipTitle={brandTitleByKey[brandKey]}
          onClick={() => {
            history.push(`${basePath}?brand=${brandKey}`);
          }}
        />
      ))}
    </SpeedDial>
  );
};
